module.exports = __webpack_public_path__ + "static/media/work_finished.df9ebbdf.svg";